import styles from './AssignationModal.module.css';
import { Alert } from '../Alert';
import WarningIcon from '../../assets/icons/warning.svg?react';
import { Button } from '../Button';
import { AlertFooter } from '../AlertFooter';
import { FormattedMessage } from 'react-intl';
import { LFC } from '../../types';

export interface ConfirmAlertProps {
  open?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}

export const ConfirmAlert: LFC<ConfirmAlertProps> = ({
  open,
  onClose,
  onConfirm,
  children,
}) => (
  <Alert open={open} onClose={onClose}>
    <WarningIcon className={styles.alertIcon} />
    {children}
    <AlertFooter>
      <Button variant="text" onClick={onClose}>
        <FormattedMessage id="Cancel" />
      </Button>
      <Button onClick={onConfirm}>
        <FormattedMessage id="Confirm" />
      </Button>
    </AlertFooter>
  </Alert>
);
